import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { AlertMessageService } from "@serpro/ngx-suite-rfb";
import { ParametrosUrl } from "src/app/atos/components/visualizar-ato/visualizar-ato.component";
import { appRoute } from "src/app/shared/consts/app-routes";
import { CONSULTA_APP_SUITE, TipoConsulta } from "src/app/shared/model/tipo-consulta.model";
import { VisaoAto } from "src/app/shared/model/visao-ato.model";
import { Visao } from "src/app/shared/model/visao.model";
import { ConsultaAppRfbService } from "src/app/shared/services/consulta-app-rfb.service";

@Component({
    selector: 'app-consulta-ato',
    templateUrl: './consulta-ato.component.html',
    styleUrls: ['./consulta-ato.component.css']
})
export class ConsultaAtoComponent implements OnInit {

    urlFuncionalidade = appRoute.consulta.consultarAto;

    visaoAto: VisaoAto | undefined;
    idAto: number;
    visaoSelecionada: Visao;
    data: string;
    tipoConsulta: TipoConsulta = CONSULTA_APP_SUITE;
    tipo: string;
    token: string;

    parametrosPagina = '';

    constructor(
        private route: ActivatedRoute,
        private alertMessageService: AlertMessageService,
        private consultaAppESuiteService: ConsultaAppRfbService,
    ) { }

    ngOnInit(): void {
        document.title = 'Normas';
        this.route.params.subscribe(() => {
            const map = this.route.snapshot.paramMap;
            const novo = map.keys.map(key => map.get(key)).join(',');
            if (this.parametrosPagina !== novo) {
                this.parametrosPagina = novo;
                this.iniciar();
            }
        });
    }

    iniciar(): void {

        this.alertMessageService.dismissAll();
        this.visaoAto = undefined;
        let parametros: ParametrosUrl;

        try {
            parametros = new ParametrosUrl(this.route.snapshot.paramMap);
        } catch (error) {
            this.alertMessageService.error(error as string);
            return;
        }

        this.idAto = parametros.idAto;
        this.visaoSelecionada = parametros.visao;
        this.tipo = parametros.tipo;
        this.token = parametros.token;

        this.consultaAppESuiteService.buscarPorIdNaVisao(this.idAto, this.visaoSelecionada, this.tipo, this.token).subscribe({
            next: retorno => {
                this.visaoAto = retorno;
            },
            error: () => null
        });
    }

    getTipoComToken(): string {
        return this.tipo + '/' + this.token;
    }
}